module.exports = __webpack_public_path__ + "static/media/checkbox-disabled.82adb346.svg";